var _a;
import { FeatureTypes } from 'common/enums/feature/feature-types.enum';
export var FeatureTypeIds = (_a = {},
    _a[FeatureTypes.virtualPoints] = 'e7e39543-1928-4d9a-97f4-be0ecdc2ffe2',
    _a[FeatureTypes.elimination] = '0a5990fa-ec79-48c7-8fd1-05240233b9cf',
    _a[FeatureTypes.goal] = '1af8242f-120a-4798-968d-592680aa8e61',
    _a[FeatureTypes.finishingConditions] = '8e4a81d3-0d10-4f93-9023-0fde842366d4',
    _a[FeatureTypes.sportLeague] = '606c28d2-b3cb-47b9-8cb4-841441167cff',
    _a);
